/**
 * @flow
 * */

import React, { PureComponent } from 'react'

import CouncilMember from './CouncilMember'
import {
  AdvisoryCouncilContainer,
  Title,
  CouncilMembersContainer
} from './styledComponents'

type Props = {
  gamingAdvisoryCouncilData: Object
}

class AdvisoryCouncilSection extends PureComponent<Props> {
  render() {
    const { gamingAdvisoryCouncilData } = this.props
    const { title, councilMembersList } = gamingAdvisoryCouncilData
    return (
      <AdvisoryCouncilContainer id="global-advisory-section">
        <Title as="h3">{title}</Title>
        <CouncilMembersContainer>
          {councilMembersList.map(({ name, designation, imageUrl }) => (
            <CouncilMember
              name={name}
              designation={designation}
              imageUrl={imageUrl}
            />
          ))}
        </CouncilMembersContainer>
      </AdvisoryCouncilContainer>
    )
  }
}

export default AdvisoryCouncilSection



// WEBPACK FOOTER //
// ./src/components/TeamNew/AdvisoryCouncilSection/index.js